// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/TungstenCond-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Teko-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/header-footer/header_background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/header-footer/footer_background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/work-thumbs/fly-app.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/work-thumbs/response-media.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/work-thumbs/my-school.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/images/work-thumbs/material_trader_mobiles.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/images/work-thumbs/tech_bros_home_demo.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/images/work-thumbs/PokeGo-mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/images/work-thumbs/rainorshine_day.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/images/work-thumbs/code_quiz.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: tungsten;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: teko;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

:root {
  --dark: rgb(9, 100, 128);
  --light: rgb(79, 181, 221);
}

html,
body {
  margin: 0;
  padding: 0;
  background: transparent;
  height: 100vh !important;
}

#page {
  position: relative;
  z-index: 0;
  height: 100vh;
}

#header-back,
#footer-back {
  position: fixed;
  left: 0;
  width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

#site-body {
  position: relative;
  z-index: 2;
}

#header-back {
  display: inline-block;
  top: 0;
  height: 400px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: bottom;
  z-index: 0;
}

#footer-back {
  bottom: 0 !important;
  height: 300px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: top;
  z-index: -1;
}

#work-page,
#resume-page,
#about-page,
#contact-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: auto;
}

/* NAVIGATION */
header {
  width: 100vw;
  padding: 30px 0px;
  height: fit-content;
  background-size: cover;
  justify-content: center;
  background-position-y: top;
}

nav {
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}

#header {
  width: 80%;
  margin: auto;
}

h1 {
  font-family: teko, sans-serif;
  font-size: 40px;
  line-height: 40px;
  margin: 0px;
  color: var(--light);
}

/* LINKS */
header a h1 {
  width: 100px;
  font-family: teko, sans-serif;
  display: inline;
  font-size: 40px;
  line-height: 40px;
  color: var(--dark);
  margin: 30px;
  text-align: center;
  text-decoration: none;
}

.h1active h1,
nav a h1:hover {
  color: white;
  transition: ease;
}

.h1:active {
  color: white;
}

a {
  border-style: none;
  text-decoration: none !important;
}

#logo {
  max-width: 140px;
  max-height: auto;
}

#logolockup {
  display: flex;
  justify-items: space-around;
  align-items: center;
  margin-bottom: 20px;
}

#logolockup div {
  margin-left: 10px;
}

#name {
  background: -webkit-linear-gradient(rgb(70, 167, 220), rgb(51, 156, 205));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 0px;
}

#name2 {
  background: -webkit-linear-gradient(rgb(59, 96, 133), rgb(15, 63, 112));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 0px;
  margin-top: -10px;
}

/* WORK */
.work-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

#work-page h3 {
  font-family: Tungsten, sans-serif;
  letter-spacing: 3px;
  text-align: left;
  font-size: 26px;
  line-height: 26px;
  color: var(--light);
  margin: 10px;
}

#work-page h3:hover {
  color: white;
}

.label {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--dark);
  padding: 5px;
  width: fit-content;
  height: 40px;
}

.git_link {
  width: 30px;
  margin: 0px 5px 0px 5px;
}

a img.hover {
  display: none;
}
a img.default {
  display: inherit;
}
a:hover img.hover {
  display: inherit;
}
a:hover img.default {
  display: none;
}

article {
  display: block;
  margin: 0px 20px 40px 20px;
  height: 300px;
  max-width: 500px;
  flex-basis: 50%;
  flex-grow: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 3px solid var(--dark);
  box-shadow: 0px 0px 26px 8px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 0px 26px 8px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0px 0px 26px 8px rgba(0, 0, 0, 0.12);
}

.work1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.work2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.work3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.work4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.work5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.work6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.work7 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.work8 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

article:hover {
  border: 3px solid var(--light);
  background-color: var(--light);
  color: var(--dark);
  filter: drop-shadow(0 0 0);
}

/* RESUME PAGE */
.experience-item {
  width: 80%;
  margin: auto;
  margin: 10px auto;
}

#resume-experience,
#resume-tools,
#resume-contact {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 25px;
  margin: 0px;
  margin-bottom: 80px;
  background-color: white;
  border: 2px solid var(--dark);
  z-index: 2;
}

#resume-experience {
  padding-bottom: 60px;
}

.centerTitle {
  align-self: center;
  text-align: center;
  margin-top: 20px;
}

.centerTitle h1 {
  color: var(--dark);
}

.resumeBtn {
  height: 30px;
}

button {
  border: none;
  background: none;
}

h2 {
  font-family: tungsten, sans-serif;
  letter-spacing: 3px;
  font-size: 21pt;
  line-height: 21pt;
  font-weight: 900;
  color: rgb(19, 19, 19);
  margin-bottom: 8px;
  margin-top: 0px;
}

h4 {
  font-family: monospace;
  color: var(--light);
  margin: 0;
}

.logos {
  margin: 20px;
  height: 85px;
  width: auto;
}

li,
ul,
h5 {
  font-family: futura, sans-serif;
  font-weight: 100;
  font-size: 14px;
  margin: 0px;
  color: var(--dark);
}

li {
  margin: 6px 0px;
}

h5 {
  margin-top: 8px;
}

.flexwork {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bullets {
  width: 80%;
}

.flexschool {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 130px;
}

.flexgrid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-content: left;
}

table {
  width: 80%;
  border: 1px solid rgb(69, 196, 255);
  border-collapse: collapse;
  text-align: center;
  margin: auto;
  margin-bottom: 35px;
}

th {
  font-family: tungsten, sans-serif;
  letter-spacing: 3px;
  font-size: 26px;
  padding: 15px;
  text-align: center;
  border: 1px solid rgb(69, 196, 255);
  border-collapse: collapse;
}

th:hover {
  color: var(--light);
}

#tableheader {
  color: white;
  font-family: paralucent, sans-serif;
  font-size: 23px;
  font-weight: 900;
  background-color: var(--dark);
  letter-spacing: 0.1em;
}

td {
  border: 1px solid var(--light);
  border-collapse: collapse;
  font-family: futura, sans-serif;
  font-weight: 100;
  font-size: 14px;
  padding: 10px;
  color: rgb(27, 27, 27);
  background-color: rgb(244, 244, 244);
}

td:hover {
  color: var(--light);
}

/* ABOUT */

.flexprofile {
  display: flex;
  padding: 0px;
  background-color: white;
  border: 2px solid var(--dark);
}

#headshot {
  display: block;
  width: 40%;
  height: auto;
}

#profile-content {
  padding: 20px;
  width: 60%;
}

#profile-content h1 {
  margin-top: 40px;
}

p {
  color: rgb(27, 27, 27);
  font-family: futura, sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 300;
  margin: 0;
  border-radius: 0 18px 18px 0;
}

.send {
  font-family: teko, sans-serif;
  letter-spacing: 3px;
  font-size: 24px;
  color: white;
  border-radius: 20px;
  border: none;
  background-color: var(--light);
  margin: 25px 0px;
  width: fit-content;
  padding: 3px 25px 0px 25px;
  align-self: center;
}

.send:hover {
  box-shadow: 0px 1px 5px rgb(44, 44, 84);
}

/* CONTACT */
#contact-form {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-around;
  background-color: var(--dark);
  height: auto;
  padding: 40px;
  margin: auto;
}

#contact-form h1 {
  color: white;
}

form {
  text-align: center;
}

input {
  width: 80%;
  margin: 10px auto 10px auto;
  padding: 5px;
  font-family: monospace;
  color: rgb(177, 177, 177);
  border: 2px solid transparent;
}

input:hover {
  border: 2px solid rgb(69, 196, 255);
}

#message {
  height: 100px;
}

#send:hover {
  color: var(--light);
  box-shadow: 0px 1px 7px rgb(15, 24, 48);
}

footer {
  position: relative;
  bottom: 0;
  text-align: center;
  height: 300px;
  width: 100%;
  z-index: 1;
}

#footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

footer a {
  color: var(--dark);
  text-decoration: none;
  font-family: teko, sans-serif;
  font-size: 16px;
  letter-spacing: 2px;
}

/* FOOTER */
.icon {
  width: auto;
  height: 50px;
  margin: 10px;
}

.icon:hover,
.resumeBtn:hover {
  filter: drop-shadow(0 2px 6px var(--light));
}

footer a:hover {
  color: var(--light);
}

p.error-text {
  color: var(--light);
  align-self: center;
  margin-top: 0;
}

@media screen and (min-width: 2200px) {
  #work-page,
  #resume-page,
  #about-page,
  #contact-page {
    width: 50%;
  }

  #work-page,
  #header {
    width: 50%;
  }

  #resume-page {
    width: 40%;
  }

  article {
    height: 400px;
    max-width: 700px;
  }
}

@media screen and (min-width: 1800px) {
  #header,
  #work-page,
  #resume-page,
  #about-page {
    width: 70%;
  }
}

@media screen and (max-width: 1500px) {
  #header,
  #work-page {
    width: 90%;
  }
}

@media screen and (max-width: 1300px) {
  nav {
    flex-direction: column;
    justify-items: center;
    margin: 0px;
  }

  .flexgrid {
    flex-direction: column;
  }

  #about-page {
    width: 50%;
  }

  #profile-content {
    width: 90%;
    padding: 20px;
  }

  .flexprofile {
    flex-direction: column;
    align-items: center;
  }

  .flexschool {
    flex-direction: row;
    max-width: fit-content;
    align-items: center;
  }

  #headshot {
    width: 100%;
    height: auto;
    margin: 0;
  }
}

@media screen and (max-width: 900px) {
  header a h1 {
    font-size: 32px;
    margin: 0px 20px;
  }

  #resume-page,
  #contact-page {
    width: 90%;
  }

  #about-page {
    width: 70%;
  }

  #readMore {
    margin-left: 35px;
  }

  .work1,
  .work2,
  .work3,
  .work4 {
    width: -webkit-fill-available;
    min-height: 300px;
  }

  .work-grid {
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
  }

  .icon {
    width: auto;
    height: 40px;
    margin: 10px;
  }

  #socials {
    text-align: center;
    margin-bottom: 20px;
  }

  .flexschool {
    width: 90%;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 501px) {
  #logo {
    max-width: 110px;
    max-height: auto;
  }

  .logos {
    height: 70px;
  }

  #logolockup {
    display: flex;
    justify-items: space-around;
    align-items: center;
    margin-bottom: 20px;
  }

  header a h1,
  .education-header h1,
  h2 {
    width: fit-content;
    font-size: 24px;
    line-height: 24px;
  }

  #about-page,
  .experience-item {
    width: 90%;
  }

  #resume-experience {
    padding: 0px;
    padding-bottom: 25px;
    margin: 0px;
  }

  header {
    flex-direction: column;
    justify-content: space-around;
  }

  article {
    margin: 0px 0px 20px 0px;
  }

  th {
    padding: 15px;
  }

  table {
    margin-bottom: 35px;
    width: 90%;
  }

  input {
    width: 90%;
  }

  #message {
    height: 100px;
  }

  .bullets {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,4CAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,MAAM;EACN,wBAAwB;EACxB,yDAA4E;EAC5E,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,yDAA4E;EAC5E,wBAAwB;EACxB,WAAW;AACb;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yEAAyE;EACzE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,uEAAuE;EACvE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,gDAAgD;EAChD,wDAAwD;EACxD,qDAAqD;AACvD;;AAEA;EACE,yDAA8D;AAChE;;AAEA;EACE,yDAAqE;AACvE;;AAEA;EACE,yDAAgE;AAClE;;AAEA;EACE,yDAA8E;AAChF;;AAEA;EACE,yDAA0E;AAC5E;;AAEA;EACE,yDAAoE;AACtE;;AAEA;EACE,0DAAsE;AACxE;;AAEA;EACE,0DAAgE;AAClE;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;;;;IAIE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;IAIE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["@font-face {\n  font-family: tungsten;\n  src: url(./assets/fonts/TungstenCond-Light.otf);\n}\n\n@font-face {\n  font-family: teko;\n  src: url(./assets/fonts/Teko-Light.ttf);\n}\n\n:root {\n  --dark: rgb(9, 100, 128);\n  --light: rgb(79, 181, 221);\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  height: 100vh !important;\n}\n\n#page {\n  position: relative;\n  z-index: 0;\n  height: 100vh;\n}\n\n#header-back,\n#footer-back {\n  position: fixed;\n  left: 0;\n  width: 100vw;\n  background-size: cover;\n  background-repeat: no-repeat;\n  z-index: -1;\n}\n\n#site-body {\n  position: relative;\n  z-index: 2;\n}\n\n#header-back {\n  display: inline-block;\n  top: 0;\n  height: 400px !important;\n  background-image: url(\"./assets/images/header-footer/header_background.png\");\n  background-position: bottom;\n  z-index: 0;\n}\n\n#footer-back {\n  bottom: 0 !important;\n  height: 300px !important;\n  background-image: url(\"./assets/images/header-footer/footer_background.png\");\n  background-position: top;\n  z-index: -1;\n}\n\n#work-page,\n#resume-page,\n#about-page,\n#contact-page {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 80%;\n  margin: auto;\n}\n\n/* NAVIGATION */\nheader {\n  width: 100vw;\n  padding: 30px 0px;\n  height: fit-content;\n  background-size: cover;\n  justify-content: center;\n  background-position-y: top;\n}\n\nnav {\n  margin: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n#header {\n  width: 80%;\n  margin: auto;\n}\n\nh1 {\n  font-family: teko, sans-serif;\n  font-size: 40px;\n  line-height: 40px;\n  margin: 0px;\n  color: var(--light);\n}\n\n/* LINKS */\nheader a h1 {\n  width: 100px;\n  font-family: teko, sans-serif;\n  display: inline;\n  font-size: 40px;\n  line-height: 40px;\n  color: var(--dark);\n  margin: 30px;\n  text-align: center;\n  text-decoration: none;\n}\n\n.h1active h1,\nnav a h1:hover {\n  color: white;\n  transition: ease;\n}\n\n.h1:active {\n  color: white;\n}\n\na {\n  border-style: none;\n  text-decoration: none !important;\n}\n\n#logo {\n  max-width: 140px;\n  max-height: auto;\n}\n\n#logolockup {\n  display: flex;\n  justify-items: space-around;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n#logolockup div {\n  margin-left: 10px;\n}\n\n#name {\n  background: -webkit-linear-gradient(rgb(70, 167, 220), rgb(51, 156, 205));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  padding: 0px;\n}\n\n#name2 {\n  background: -webkit-linear-gradient(rgb(59, 96, 133), rgb(15, 63, 112));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  padding: 0px;\n  margin-top: -10px;\n}\n\n/* WORK */\n.work-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n}\n\n#work-page h3 {\n  font-family: Tungsten, sans-serif;\n  letter-spacing: 3px;\n  text-align: left;\n  font-size: 26px;\n  line-height: 26px;\n  color: var(--light);\n  margin: 10px;\n}\n\n#work-page h3:hover {\n  color: white;\n}\n\n.label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: var(--dark);\n  padding: 5px;\n  width: fit-content;\n  height: 40px;\n}\n\n.git_link {\n  width: 30px;\n  margin: 0px 5px 0px 5px;\n}\n\na img.hover {\n  display: none;\n}\na img.default {\n  display: inherit;\n}\na:hover img.hover {\n  display: inherit;\n}\na:hover img.default {\n  display: none;\n}\n\narticle {\n  display: block;\n  margin: 0px 20px 40px 20px;\n  height: 300px;\n  max-width: 500px;\n  flex-basis: 50%;\n  flex-grow: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  border: 3px solid var(--dark);\n  box-shadow: 0px 0px 26px 8px rgba(0, 0, 0, 0.12);\n  -webkit-box-shadow: 0px 0px 26px 8px rgba(0, 0, 0, 0.12);\n  -moz-box-shadow: 0px 0px 26px 8px rgba(0, 0, 0, 0.12);\n}\n\n.work1 {\n  background-image: url(./assets/images/work-thumbs/fly-app.png);\n}\n\n.work2 {\n  background-image: url(./assets/images/work-thumbs/response-media.png);\n}\n\n.work3 {\n  background-image: url(./assets/images/work-thumbs/my-school.png);\n}\n\n.work4 {\n  background-image: url(./assets/images/work-thumbs/material_trader_mobiles.png);\n}\n\n.work5 {\n  background-image: url(./assets/images/work-thumbs/tech_bros_home_demo.jpg);\n}\n\n.work6 {\n  background-image: url(./assets/images/work-thumbs/PokeGo-mobile.png);\n}\n\n.work7 {\n  background-image: url(./assets/images/work-thumbs/rainorshine_day.png);\n}\n\n.work8 {\n  background-image: url(./assets/images/work-thumbs/code_quiz.jpg);\n}\n\narticle:hover {\n  border: 3px solid var(--light);\n  background-color: var(--light);\n  color: var(--dark);\n  filter: drop-shadow(0 0 0);\n}\n\n/* RESUME PAGE */\n.experience-item {\n  width: 80%;\n  margin: auto;\n  margin: 10px auto;\n}\n\n#resume-experience,\n#resume-tools,\n#resume-contact {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 25px;\n  margin: 0px;\n  margin-bottom: 80px;\n  background-color: white;\n  border: 2px solid var(--dark);\n  z-index: 2;\n}\n\n#resume-experience {\n  padding-bottom: 60px;\n}\n\n.centerTitle {\n  align-self: center;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.centerTitle h1 {\n  color: var(--dark);\n}\n\n.resumeBtn {\n  height: 30px;\n}\n\nbutton {\n  border: none;\n  background: none;\n}\n\nh2 {\n  font-family: tungsten, sans-serif;\n  letter-spacing: 3px;\n  font-size: 21pt;\n  line-height: 21pt;\n  font-weight: 900;\n  color: rgb(19, 19, 19);\n  margin-bottom: 8px;\n  margin-top: 0px;\n}\n\nh4 {\n  font-family: monospace;\n  color: var(--light);\n  margin: 0;\n}\n\n.logos {\n  margin: 20px;\n  height: 85px;\n  width: auto;\n}\n\nli,\nul,\nh5 {\n  font-family: futura, sans-serif;\n  font-weight: 100;\n  font-size: 14px;\n  margin: 0px;\n  color: var(--dark);\n}\n\nli {\n  margin: 6px 0px;\n}\n\nh5 {\n  margin-top: 8px;\n}\n\n.flexwork {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.bullets {\n  width: 80%;\n}\n\n.flexschool {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 130px;\n}\n\n.flexgrid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-content: left;\n}\n\ntable {\n  width: 80%;\n  border: 1px solid rgb(69, 196, 255);\n  border-collapse: collapse;\n  text-align: center;\n  margin: auto;\n  margin-bottom: 35px;\n}\n\nth {\n  font-family: tungsten, sans-serif;\n  letter-spacing: 3px;\n  font-size: 26px;\n  padding: 15px;\n  text-align: center;\n  border: 1px solid rgb(69, 196, 255);\n  border-collapse: collapse;\n}\n\nth:hover {\n  color: var(--light);\n}\n\n#tableheader {\n  color: white;\n  font-family: paralucent, sans-serif;\n  font-size: 23px;\n  font-weight: 900;\n  background-color: var(--dark);\n  letter-spacing: 0.1em;\n}\n\ntd {\n  border: 1px solid var(--light);\n  border-collapse: collapse;\n  font-family: futura, sans-serif;\n  font-weight: 100;\n  font-size: 14px;\n  padding: 10px;\n  color: rgb(27, 27, 27);\n  background-color: rgb(244, 244, 244);\n}\n\ntd:hover {\n  color: var(--light);\n}\n\n/* ABOUT */\n\n.flexprofile {\n  display: flex;\n  padding: 0px;\n  background-color: white;\n  border: 2px solid var(--dark);\n}\n\n#headshot {\n  display: block;\n  width: 40%;\n  height: auto;\n}\n\n#profile-content {\n  padding: 20px;\n  width: 60%;\n}\n\n#profile-content h1 {\n  margin-top: 40px;\n}\n\np {\n  color: rgb(27, 27, 27);\n  font-family: futura, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 300;\n  margin: 0;\n  border-radius: 0 18px 18px 0;\n}\n\n.send {\n  font-family: teko, sans-serif;\n  letter-spacing: 3px;\n  font-size: 24px;\n  color: white;\n  border-radius: 20px;\n  border: none;\n  background-color: var(--light);\n  margin: 25px 0px;\n  width: fit-content;\n  padding: 3px 25px 0px 25px;\n  align-self: center;\n}\n\n.send:hover {\n  box-shadow: 0px 1px 5px rgb(44, 44, 84);\n}\n\n/* CONTACT */\n#contact-form {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: space-around;\n  background-color: var(--dark);\n  height: auto;\n  padding: 40px;\n  margin: auto;\n}\n\n#contact-form h1 {\n  color: white;\n}\n\nform {\n  text-align: center;\n}\n\ninput {\n  width: 80%;\n  margin: 10px auto 10px auto;\n  padding: 5px;\n  font-family: monospace;\n  color: rgb(177, 177, 177);\n  border: 2px solid transparent;\n}\n\ninput:hover {\n  border: 2px solid rgb(69, 196, 255);\n}\n\n#message {\n  height: 100px;\n}\n\n#send:hover {\n  color: var(--light);\n  box-shadow: 0px 1px 7px rgb(15, 24, 48);\n}\n\nfooter {\n  position: relative;\n  bottom: 0;\n  text-align: center;\n  height: 300px;\n  width: 100%;\n  z-index: 1;\n}\n\n#footer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\nfooter a {\n  color: var(--dark);\n  text-decoration: none;\n  font-family: teko, sans-serif;\n  font-size: 16px;\n  letter-spacing: 2px;\n}\n\n/* FOOTER */\n.icon {\n  width: auto;\n  height: 50px;\n  margin: 10px;\n}\n\n.icon:hover,\n.resumeBtn:hover {\n  filter: drop-shadow(0 2px 6px var(--light));\n}\n\nfooter a:hover {\n  color: var(--light);\n}\n\np.error-text {\n  color: var(--light);\n  align-self: center;\n  margin-top: 0;\n}\n\n@media screen and (min-width: 2200px) {\n  #work-page,\n  #resume-page,\n  #about-page,\n  #contact-page {\n    width: 50%;\n  }\n\n  #work-page,\n  #header {\n    width: 50%;\n  }\n\n  #resume-page {\n    width: 40%;\n  }\n\n  article {\n    height: 400px;\n    max-width: 700px;\n  }\n}\n\n@media screen and (min-width: 1800px) {\n  #header,\n  #work-page,\n  #resume-page,\n  #about-page {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 1500px) {\n  #header,\n  #work-page {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  nav {\n    flex-direction: column;\n    justify-items: center;\n    margin: 0px;\n  }\n\n  .flexgrid {\n    flex-direction: column;\n  }\n\n  #about-page {\n    width: 50%;\n  }\n\n  #profile-content {\n    width: 90%;\n    padding: 20px;\n  }\n\n  .flexprofile {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .flexschool {\n    flex-direction: row;\n    max-width: fit-content;\n    align-items: center;\n  }\n\n  #headshot {\n    width: 100%;\n    height: auto;\n    margin: 0;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  header a h1 {\n    font-size: 32px;\n    margin: 0px 20px;\n  }\n\n  #resume-page,\n  #contact-page {\n    width: 90%;\n  }\n\n  #about-page {\n    width: 70%;\n  }\n\n  #readMore {\n    margin-left: 35px;\n  }\n\n  .work1,\n  .work2,\n  .work3,\n  .work4 {\n    width: -webkit-fill-available;\n    min-height: 300px;\n  }\n\n  .work-grid {\n    flex-direction: column;\n    justify-content: space-around;\n    align-content: center;\n  }\n\n  .icon {\n    width: auto;\n    height: 40px;\n    margin: 10px;\n  }\n\n  #socials {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  .flexschool {\n    width: 90%;\n    margin-bottom: 20px;\n  }\n}\n\n@media screen and (max-width: 501px) {\n  #logo {\n    max-width: 110px;\n    max-height: auto;\n  }\n\n  .logos {\n    height: 70px;\n  }\n\n  #logolockup {\n    display: flex;\n    justify-items: space-around;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n\n  header a h1,\n  .education-header h1,\n  h2 {\n    width: fit-content;\n    font-size: 24px;\n    line-height: 24px;\n  }\n\n  #about-page,\n  .experience-item {\n    width: 90%;\n  }\n\n  #resume-experience {\n    padding: 0px;\n    padding-bottom: 25px;\n    margin: 0px;\n  }\n\n  header {\n    flex-direction: column;\n    justify-content: space-around;\n  }\n\n  article {\n    margin: 0px 0px 20px 0px;\n  }\n\n  th {\n    padding: 15px;\n  }\n\n  table {\n    margin-bottom: 35px;\n    width: 90%;\n  }\n\n  input {\n    width: 90%;\n  }\n\n  #message {\n    height: 100px;\n  }\n\n  .bullets {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
